import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_NOTES_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientNotesArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_NOTES } from '../redux/action-types'

const useUpdateIngredientNotesMutation = () => {
  const dispatch = useDispatch()

  const { isNotesLoading, notesError } = useSelector(
    store => store.ingredients.ingredient,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_NOTES_MUTATION,
        { id, data: transformToUpdateIngredientNotesArgs(data) },
        dispatch,
        UPDATE_INGREDIENT_NOTES,
      ),
    [dispatch],
  )

  return [mutate, { isLoading: isNotesLoading, error: notesError }]
}

export default useUpdateIngredientNotesMutation
